// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-payment_stripe-sofort',
    // #endregion
    // #region Properties
    props: {
        gateway: {
            type: Object,
            required: true,
            default: {}
        },
        method: {
            type: Object,
            required: true,
            default: {}
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        paymentErrors: '',
        _gateway: {},
        _card: {},
    }),
    // #endregion
    // #region Mount
    beforeMount() {
        //Bus
        this.$host.eventBus.on('checkout-before-commit', this.CreatePaymentMethod);
        //Gateway
        this._gateway = this.$host.provider.get('PAYMENT', this.gateway.clientType);
        //Init
        this._gateway.initialize(this.gateway)
            .then(e => {
        });
    },
    beforeUnmount() {
        this.$host.eventBus.off('checkout-before-commit', this.CreatePaymentMethod);
    },
    // #endregion
    // #region Core
    methods: {
        async CreatePaymentMethod(args) {
            // #region Core
            try {
                //Run
                let tResult = await this._gateway.api.createPaymentMethod({
                    type: 'sofort',
                    sofort: {
                        country: "DE"
                    },
                    billing_details: {
                        address: {
                            country: 'de'
                        },
                    }
                });
                //Result
                args.data.payment.details = {
                    paymentID: tResult.paymentMethod.id
                };
            }
            // #endregion
            // #region Error
            catch (error) {
                this.paymentErrors = error;
                args.cancel = true;
            }
            // #endregion
        },
        onPaymentChange(event) {
            if (event.error) {
                this.paymentErrors = event.error.message;
            }
            else {
                this.paymentErrors = '';
            }
        },
    },
    // #endregion
});
// #endregion
